/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetQuestionModel,
  IGetQuestionRequest,
  IMappers,
  IGetQuestionResponse,
  IGetQuestionResponseError,
  TGetQuestionResponse,
} from './types';

const defaultConfig: TGetQuestionModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'quiz',
  pathApi: '/v1/get-question/',
  hostType: 'api',
} as TGetQuestionModel;

function createGetQuestionModel(parameters: IGetQuestionRequest): TGetQuestionModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetQuestionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetQuestionRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetQuestion<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetQuestionOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetQuestionResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetQuestionModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetQuestionResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetQuestionResponseError);
    }
  }

  return { response, statusCode } as TGetQuestionResponse;
}

export { defaultConfig, createGetQuestionModel, fetchGetQuestion };
